import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'sortByDate'
})
export class SortByDatePipe implements PipeTransform {
	public transform(arrToTransform: Array<any>, optsToTransform: object): any {
		const toString = Object.prototype.toString,
			// Default parser
			parseFn = item => item,
			// Get the item to sort
			getItem = function (item): any {
				return this['parser']((item !== null && typeof item === 'object' && item[this['key']]) || item);
			};

		/**
		 * @desc    : Creating comparator method for sorting an array
		 * @ param   : arr<Array>        => A list of objects
		 * @ param   : opts<Object>      =>  Configurable object that controls the code from outside
		 * @ param   : opts.key<string>  => Specifies prop of the object in the list
		 * @ param   : opts.parser<Function>
		 */
		const comparatorFn = function (arr, opts): any[] {
			if (!(arr instanceof Array) || !arr.length) { return []; }

			if (toString.call(opts) !== '[object Object]') { opts = {}; }

			// If parser is not specified lets use default parser
			if (typeof opts.parser !== 'function') { opts.parser = parseFn; }
			// Setup the sorting order
			opts.order = !!opts.order ? -1 : 1;
			opts.key = opts.key || 'title';

			return arr.sort((a, b) => {
				const x = getItem.call(opts, a),
					y = getItem.call(opts, b);

				if (x === null && y === null) { return 1; }
				else if (x === null) { return 1; }
				else if (y === null) { return -1; }
				else { return opts.order * (x < y ? -1 : +(x > y)); }
			});
		};

		return comparatorFn(arrToTransform, optsToTransform);
	}
}
